import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { QueryKey } from '../types/growth-query-key';
import { useInvalidateGoalById } from './use-goals';

interface AppendGoalToV2MeetingResponse {
	success: boolean;
	message: string;
	meeting_id?: string;
	other_participant_name?: string;
}

interface AppendGoalToV2MeetingRequest {
	goalId: string;
}

// Hook to append a goal to the V2 meeting's collaborative document (V2 equivalent of "Discuss in 1:1")
export const useAppendGoalToV2Meeting = () => {
	const http = useHttpClient('v2');
	const queryClient = useQueryClient();
	const invalidateGoalById = useInvalidateGoalById();

	return useMutation(
		async ({ goalId }: AppendGoalToV2MeetingRequest) => {
			const res = await http.post<AppendGoalToV2MeetingResponse>('/one_on_ones/meetings_v2/append_goal', {
				goal_id: goalId,
			});
			return res.data;
		},
		{
			onSuccess: (data, variables) => {
				// Invalidate V2 meeting queries to reflect the document update
				queryClient.invalidateQueries([QueryKey.MeetingV2]);
				// Also invalidate the goal to update UI states
				invalidateGoalById(variables.goalId);
			},
		}
	);
};
